import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';
import cookie from 'react-cookie';
import { connect } from 'react-redux';

import { getLoginCode, getUserInfo } from '../../actions';

import TextFeild from '../../component/textFeild';
import { browserHistory } from 'react-router';
import Title from '../../component/title';
import Button from '../../component/button';

class Home extends Component {
    constructor(props){
		super(props);
		
		this.state = {
			'phoneNum' : cookie.load('phoneNum')
		}

        props.getUserInfo().then((res) => {
			if(res.id) browserHistory.push('/applyMain');
		});

		this.phoneInputChange = (e) => {
			this.setState(e.value);
		}

        this.sendPhone = (e) => {
			let phoneNum = this.refs.phoneInput.state.data;
			if(phoneNum.match('^09[0-9]{8}$')) {
				cookie.save('phoneNum', phoneNum, { path: '/', maxAge: 31536000});
				this.props.getLoginCode({ phoneNum: phoneNum});				
			} else {
				alert('請輸入台灣格式的手機號碼');
			}
        }
        this.handleKeydown = (e) => {
			if( e.key === 'Enter') {
				this.sendPhone();
			}
		}
    }
	render() {
		return (
			<div styleName="">
				<Title>開始使用武林文創</Title>
				<div className="hint">請輸入您的手機號碼</div>
                <TextFeild styleName="input" ref="phoneInput" onChange={this.phoneInputChange} value={this.state.phoneNum} onKeyDown={this.handleKeydown}/>
                
				<Button styleName="button" onClick={this.sendPhone}>進入</Button>
                <div className="hint"><p>我們使用手機號碼來識別會員身分，</p><p>不做電話行銷也不會外流。</p></div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.data.user
	};
}

export default connect(mapStateToProps, { getLoginCode, getUserInfo })(CSSModule(Home,css, {allowMultiple:true}));




/** WEBPACK FOOTER **
 ** ./src/container/home/index.js
 **/